var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9732 10.9463L7.50393 10.9463L12.5147 5.80441C12.9151 5.39348 12.9151 4.71913 12.5147 4.3082C12.1142 3.89727 11.4673 3.89727 11.0669 4.3082L4.30034 11.2519C3.89989 11.6628 3.89989 12.3266 4.30034 12.7376L11.0566 19.6918C11.4571 20.1027 12.104 20.1027 12.5044 19.6918C12.9049 19.2809 12.9049 18.6171 12.5044 18.2061L7.50393 13.0537L18.9732 13.0537C19.5379 13.0537 20 12.5795 20 12C20 11.4205 19.5379 10.9463 18.9732 10.9463Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.3bbfd34bcbf6a8915428fe29bdc9a931.svg";
export { ForwardRef as ReactComponent };